import type { Account } from '@ps/web-core-store';

import type { ModelConfig } from '@swf/core/store';

import effects from './effects';
import selectors from './selectors';

interface AccountModel extends ModelConfig<AccountState> {
  effects: typeof effects;
  reducers: typeof reducers;
  selectors: typeof selectors;
}

export type AccountState = Partial<Account> & {
  userLimits?: number;
};

const reducers = {
  'session/clear': () => account.state,
  update: (state: AccountState, payload: AccountState) => ({ ...state, ...payload })
};

const account: AccountModel = {
  state: {},
  effects,
  reducers,
  selectors
};

export default account;
